import { LinkItem } from '@occc-app/design-system';
import { Transaction_Event_Type } from '@occc/graphql';

export const breadcrumbLinks: LinkItem[] = [
  {
    to: '/transactions',
    label: 'Transactions',
  },
  {
    key: '/transactions/transaction-details',
    label: 'Transaction Details',
  },
];

export const transactionEventTypeLabelsMap: Record<Transaction_Event_Type, string> = {
  [Transaction_Event_Type.Auth]: 'Auth',
  [Transaction_Event_Type.FullRefund]: 'Full Refund',
  [Transaction_Event_Type.InvalidAction]: 'Invalid Action',
  [Transaction_Event_Type.PartialRefund]: 'Partial Refund',
  [Transaction_Event_Type.PreAuth]: 'Pre Auth',
  [Transaction_Event_Type.Settled]: 'Settled',
  [Transaction_Event_Type.Void]: 'Void',
};
